module.exports = __webpack_public_path__ + "static/ing-964977bd559ab0f51886121080d3dae7.svg";